export default __webpack_public_path__ + "static/media/ds2.03699287.jpg";